// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1wLhg","newExpiryDate":"styles_newExpiryDate__2bFHw","footer":"styles_footer__dSba-"};